'use client';

import { c as _c } from "react/compiler-runtime";
import { FeatherActivity, FeatherAlertTriangle, FeatherDollarSign, FeatherLock, FeatherXCircle } from '@subframe/core';
import { StatsCard } from '@/shared/components/ui';
import type { ApuracaoListSummary } from '../types';
import { formatarMoedaBR } from '../utils/apuracaoFormatters';
interface ApuracaoListSummaryCardsProps {
  summary: ApuracaoListSummary;
}
export function ApuracaoListSummaryCards(t0) {
  const $ = _c(23);
  const {
    summary
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <FeatherActivity className="text-warning-600" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== summary.totalAbertos) {
    t2 = <StatsCard label="Ciclos abertos" value={summary.totalAbertos} icon={t1} />;
    $[1] = summary.totalAbertos;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <FeatherAlertTriangle className="text-warning-600" />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== summary.vencendoEmAteSeteDias) {
    t4 = <StatsCard label={"Vencendo em \u22647 dias"} value={summary.vencendoEmAteSeteDias} icon={t3} />;
    $[4] = summary.vencendoEmAteSeteDias;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <FeatherLock className="text-success-600" />;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== summary.fechadosNoMes) {
    t6 = <StatsCard label={"Fechados no m\xEAs"} value={summary.fechadosNoMes} icon={t5} />;
    $[7] = summary.fechadosNoMes;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <FeatherXCircle className="text-error-600" />;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== summary.comErros) {
    t8 = <StatsCard label="Com erros pendentes" value={summary.comErros} icon={t7} />;
    $[10] = summary.comErros;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== summary.totalCobravelPrevisto) {
    t9 = formatarMoedaBR(summary.totalCobravelPrevisto);
    $[12] = summary.totalCobravelPrevisto;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <FeatherDollarSign className="text-brand-600" />;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== t9) {
    t11 = <StatsCard label={"Cobr\xE1vel previsto"} value={t9} icon={t10} />;
    $[15] = t9;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== t11 || $[18] !== t2 || $[19] !== t4 || $[20] !== t6 || $[21] !== t8) {
    t12 = <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-5">{t2}{t4}{t6}{t8}{t11}</div>;
    $[17] = t11;
    $[18] = t2;
    $[19] = t4;
    $[20] = t6;
    $[21] = t8;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  return t12;
}